// removed by extract-text-webpack-plugin
module.exports = {"request-form-modal-open":"request-form-modal-open","root":"root","ReactModal__Content":"ReactModal__Content","ReactModal__Overlay":"ReactModal__Overlay","send-request-popup":"send-request-popup","send-request-popup-content-wrap":"send-request-popup-content-wrap","send-request-form-title":"send-request-form-title","btn-close-send-request":"btn-close-send-request","btn-send-request":"btn-send-request"};


//////////////////
// WEBPACK FOOTER
// ./components/partials/product/send-request/style.scss
// module id = ./components/partials/product/send-request/style.scss
// module chunks = 0